import { render } from "./UserInfoCard.vue?vue&type=template&id=4a60b8f6"
import script from "./UserInfoCard.vue?vue&type=script&lang=js"
export * from "./UserInfoCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__